import { render } from "./MainTitle.vue?vue&type=template&id=3bf00166&scoped=true"
const script = {}

import "./MainTitle.vue?vue&type=style&index=0&id=3bf00166&scoped=true&lang=css"

import exportComponent from "E:\\Marianne\\workspace\\notion-cooks\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bf00166"]])

export default __exports__